import type {QueryClient} from '@tanstack/react-query';

import {QUERY_CLIENT_MAX_AGE} from './constants.js';
import type {PersistedQueryConfig, PrefetchQueryConfig} from './types.js';

export function shouldPersistQuery(
  queryKey: unknown[],
  persistedQueries: PersistedQueryConfig[]
): boolean {
  if (!Array.isArray(queryKey) || queryKey.length === 0) return false;
  const firstKey = String(queryKey[0]);
  return persistedQueries.some(config => config.keyPrefix === firstKey);
}

export function getQueryMaxAge(
  queryKey: unknown[],
  persistedQueries: PersistedQueryConfig[]
): number {
  if (!Array.isArray(queryKey) || queryKey.length === 0) {
    return QUERY_CLIENT_MAX_AGE;
  }
  const firstKey = String(queryKey[0]);
  const config = persistedQueries.find(c => c.keyPrefix === firstKey);
  return config?.maxAge ?? QUERY_CLIENT_MAX_AGE;
}

export function prefetchQueries(
  queryClient: QueryClient,
  queries: PrefetchQueryConfig[]
): void {
  queries.forEach(({queryKey, queryFn}) => {
    queryClient.prefetchQuery({queryKey, queryFn});
  });
}
